<mat-form-field class="fuse-mat-no-subscript w-full"
                [ngClass]="classes"
                [formGroup]="form"
                [floatLabel]="floatLabel">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input matInput [required]="required" [placeholder]="placeholder" [imask]="mask" (complete)="valueChanged($event)" [formControl]="dateTextParserControl">
    <input matInput [matDatepicker]="picker" [formControlName]="controlName" class="hidden" (dateChange)="dateChanged($event.value)">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
